/**
 * app.ResourceLoader can be used to load scripts when needed.
 * It ensures that every script is only loaded once.
 */
var app = app || {};
(function ($) {

    /* UrlStates enum */
    var UrlStates = {
        LOADING: "LOADING",
        LOADED: "LOADED",
        FAILED: "FAILED"
    };

    /* UrlInfo class */
    function UrlInfo() {
        this.state = UrlStates.LOADING;
        this.loadCallbacks = [];
        this.failCallbacks = [];
    }

    UrlInfo.prototype.succeed = function () {
        this.state = UrlStates.LOADED;
        for (let i = 0; i < this.loadCallbacks.length; i++) {
            this.loadCallbacks[i]();
        }
    };

    UrlInfo.prototype.failed = function () {
        this.state = UrlStates.FAILED;
        for (let i = 0; i < this.failCallbacks.length; i++) {
            this.failCallbacks[i]();
        }
    };

    UrlInfo.prototype.handleCallbacks = function (loadCallback, failCallback) {
        switch (this.state) {
            case UrlStates.LOADED:
                loadCallback && loadCallback();
                break;
            case UrlStates.FAILED:
                failCallback && failCallback();
                break;
            case UrlStates.LOADING:
                this.addCallbacks(loadCallback, failCallback);
                break;
        }
    };

    UrlInfo.prototype.addCallbacks = function (loadCallback, failCallback) {
        loadCallback && this.loadCallbacks.push(loadCallback);
        failCallback && this.failCallbacks.push(failCallback);
    };

    /* ResourceLoader API */

    app.ResourceLoader = (function () {
        var _urlInfos = {};

        const _loadScript = function (url, loadCallback, failCallback) {
            var urlInfo = _urlInfos[url];

            if (urlInfo) {
                urlInfo.handleCallbacks(loadCallback, failCallback);
                return;
            }

            _urlInfos[url] = urlInfo = new UrlInfo();
            urlInfo.addCallbacks(loadCallback, failCallback);

            return $.cachedGet(url)
                .done(function (script, textStatus) {
                    urlInfo.succeed();
                })
                .fail(function (jqxhr, settings, exception) {
                    urlInfo.failed();
                });
        };

        const _loadStyle = function (url) {
            var urlInfo = _urlInfos[url];

            if (urlInfo) {
                return;
            }

            _urlInfos[url] = urlInfo = new UrlInfo();

            // if Development environment, don't cache by generating new timestamp each time.
            const timestamp = app.session.application.environment && app.session.application.environment.toLowerCase().indexOf("development") !== -1
                ? app.utils.dateTime.getTicks(new Date())
                : app.utils.dateTime.getTicks(new Date(app.session.application.releaseDate));

            const uri = new window.URI(url)
                .search({
                    v: timestamp
                });
            $("head").append($(`<link rel="stylesheet" href="${uri.toString()}" type="text/css" />`));

            urlInfo.succeed();
        };

        return {
            loadScript: _loadScript,
            loadStyle: _loadStyle
        };
    })();
})(jQuery);
